// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const ropewalk = defineModel({
  id: "ropewalk",
  batchId: "future",
  name: "Ropewalk",
  tags: ["building","ropewalk","low-poly","age-of-mcp","future"],
  summary: "Lays fibre into rope — used by ships, wells, cranes and scaffolds everywhere.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.95, 0.14, 1.95), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.95, 0.14, 1.95), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.9, 0.4, 0.7), color: "#a8804a", position: [0, 0.34, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.4, 0.1), color: "#7a5a30", position: [-0.95, 0.34, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.4, 0.1), color: "#7a5a30", position: [0.95, 0.34, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.4, 0.1), color: "#7a5a30", position: [-0.95, 0.34, 0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.4, 0.1), color: "#7a5a30", position: [0.95, 0.34, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.85, 0.425, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.85, 0.425, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.85, 0.425, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.85, 0.425, 0.85] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.95, 0.14, 1.95), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.9, 0.78, 0.7), color: "#a8804a", position: [0, 0.53, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [-0.95, 0.53, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [0.95, 0.53, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [-0.95, 0.53, 0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [0.95, 0.53, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.25, 4), color: "#6b4a26", position: [-0.85, 0.625, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.25, 4), color: "#6b4a26", position: [0.85, 0.625, -0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.25, 4), color: "#6b4a26", position: [-0.85, 0.625, 0.85] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.25, 4), color: "#6b4a26", position: [0.85, 0.625, 0.85] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.95, 0.14, 1.95), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.9, 0.78, 0.7), color: "#a8804a", position: [0, 0.53, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [-0.95, 0.53, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [0.95, 0.53, -0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [-0.95, 0.53, 0.35] },
      { geometry: new THREE.BoxGeometry(0.1, 0.78, 0.1), color: "#7a5a30", position: [0.95, 0.53, 0.35] },
      { geometry: new THREE.BoxGeometry(2.12, 0.07, 0.605619), color: "#7a4a36", position: [0, 1.1, 0.205], rotation: [0.720554, 0, 0] },
      { geometry: new THREE.BoxGeometry(2.12, 0.07, 0.605619), color: "#7a4a36", position: [0, 1.1, -0.205], rotation: [-0.720554, 0, 0] },
      { geometry: new THREE.BoxGeometry(2.14, 0.085, 0.085), color: "#5a3526", position: [0, 1.28, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.36] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.36, 6), color: "#8a5f33", position: [-0.76, 0.32, 0.53] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.36, 6), color: "#8a5f33", position: [-0.38, 0.32, 0.53] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.36, 6), color: "#8a5f33", position: [0, 0.32, 0.53] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.36, 6), color: "#8a5f33", position: [0.38, 0.32, 0.53] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.36, 6), color: "#8a5f33", position: [0.76, 0.32, 0.53] },
      { geometry: new THREE.CylinderGeometry(0.035, 0.035, 1.7, 6), color: "#c2a86a", position: [0, 0.5, 0.53], rotation: [0, 0, 1.570796] },
    ] },
  ],
  animations: [],
});
